<template>
  <footer>
    <ul v-if="token">
      <li><router-link :to="{ name: 'ClientDashboard'}">Home</router-link></li>
      <li><router-link :to="{ name: 'EarnPoints'}">Earn Points</router-link></li>
      <li><router-link :to="{ name: 'RedeemPoints'}">Redeem Points</router-link></li>
      <li><router-link :to="{ name: 'RulesAndTerms'}">Rules/Terms &amp; Conditions</router-link></li>
      <li><router-link :to="{ name: 'Account'}">My Account</router-link></li>
      <li><a href="#" @click.prevent="logout">Logout</a></li>
    </ul>

    <br><br>
    <p v-if="token">For questions please email <a href="mailto:rewards@mercuryfs.com">rewards@mercuryfs.com</a></p>
    <p>Copyright © 2019 Mercury Fulfillment Systems, Inc. All Rights Reserved.</p>
  </footer>
</template>

<script>
export default {
  name: 'ClientFooter',
  data () {
    return {
      token: localStorage.getItem('jwtToken')
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('jwtToken')
      localStorage.removeItem('user')
      this.$router.push({
        name: 'ClientLogin'
      })
    }
  }
}
</script>
